<template>
  <div class="monitoringresults">
    <div class="top">
      注:本报告所涉内容，为根据您的体内环境毒素定性检测情况，对您日常生活方式，生活习惯的分析评估及健康指导建议。不作为医学临床诊断之用。
      <span @click="openpop">了解更多</span>
    </div>
    <div class="canvas">
      <div class="c_top">
        <div class="left" @click="gohistory">
          <img src="../assets/images/lishijil@2x.png"/>历史记录
        </div>
        <div
          class="right"
          @click="gohome"
        >
          <img
            style="width: 0.50667rem;
    height: 0.50667rem;
    margin-right: 0.13333rem;display:inline-block;vertical-align: middle;"
            src="../assets/images/gerenzhongxin.png"
          />个人中心
        </div>
        <!-- <div class="center">2019-11-22 11:30:30</div> -->
      </div>


      <div class="chatsbottom">

        <div class="span1">
          <p>安全值</p>
          <p>90%</p>
        </div>
        <div class="row">
          <div class="solid"></div>
          <div class="zzt">
            <img src="../assets/images/cb.png" v-if="detail.nicotine==1"/>
            <div class="zztitem" v-if="detail.nicotine==1||detail.nicotine==2"></div>
            <div class="zztitem1" v-if="detail.nicotine==1"></div>
            <div class="zztitem" v-if="detail.nicotine==2"></div>
          </div>
          <div class="zzt">
            <img src="../assets/images/cb.png" v-if="detail.bpa==1"/>
            <div class="zztitem" v-if="detail.bpa==1 ||detail.bpa==2"></div>
            <div class="zztitem1" v-if="detail.bpa==1"></div>
            <div class="zztitem" v-if="detail.bpa==2"></div>
          </div>
          <div class="zzt">
            <img src="../assets/images/cb.png" v-if="detail.lemon_yellow==1"/>
            <div class="zztitem" v-if="detail.lemon_yellow==1||detail.lemon_yellow==2"></div>
            <div class="zztitem1" v-if="detail.lemon_yellow==1"></div>
            <div class="zztitem" v-if="detail.lemon_yellow==2"></div>
          </div>
          <div class="zzt">
            <img src="../assets/images/cb.png" v-if="detail.brown_meat==1"/>
            <div class="zztitem" v-if="detail.brown_meat==1||detail.brown_meat==2"></div>
            <div class="zztitem1" v-if="detail.brown_meat==1"></div>
            <div class="zztitem" v-if="detail.brown_meat==2"></div>
          </div>
          <div class="zzt">
            <img src="../assets/images/cb.png" v-if="detail.chloramphenicol==1"/>
            <div class="zztitem" v-if="detail.chloramphenicol==1 ||detail.chloramphenicol==2"></div>
            <div class="zztitem1" v-if="detail.chloramphenicol==1"></div>
            <div class="zztitem" v-if="detail.chloramphenicol==2"></div>
          </div>
        </div>

        <div class="row1">
          <div class="item">尼古丁</div>
          <div class="item">双酚A</div>
          <div class="item">柠檬黄</div>
          <div class="item">瘦肉精</div>
          <div class="item">氯霉素</div>
        </div>
      </div>
      <p class="jyday">建议您60天后再次检测</p>


    </div>
    <div class="bottom">
      <div class="b_row1">
        <router-link
          :to="{ name: 'shopDetail', params: { 'commodity_id': DeterGoodeatil.commodity_id }}"
        >
          <div class="btn">点击购买</div>
        </router-link>
        <div class="center">
          <p class="p1">{{DeterGoodeatil.title}}</p>
          <p class="p2">{{DeterGoodeatil.title1}}</p>
        </div>
        <div class="right">
          <img :src="DeterGoodeatil.img"/>
        </div>
      </div>
      <div class="b_row2">
        <p>
          亲爱的
          <span>{{detail.user_name}}</span>您好
        </p>
        <p>感谢您对恩氏基因的信赖，选择了爱贝亚测毒卡，关注自身生活方式及饮食健康。</p>
        <p>我们根据您反馈的毒素测定情况，汇总分析如下，如需帮助请拨打：</p>
        <p>
          联系电话：
          <a :href="'tel:4006878036'">4006878036</a>，祝您生活愉快
        </p>
      </div>
      <div class="b_row3">
        <div class="title">
          <img src="../assets/images/huizong@2x.png"/>汇总分析
        </div>
        <div class="cnt">
          <p class="p1" v-if="isnormal==true">
            本次检测显示:
            <span style="color: #27d3ad;">正常</span><br>
            <span >很棒，今天的环境毒素检测正常，请继续保持，好身体会回报您的。</span>
          </p>
          <p class="p2" v-else>本次检测显示，您体内的：</p>
          <div class="cbrow" v-if="isnormal==false">
            <div class="item" v-if="detail.nicotine==1">尼古丁</div>
            <div class="item" v-if="detail.bpa==1">双酚A</div>
            <div class="item" v-if="detail.lemon_yellow==1">柠檬黄</div>
            <div class="item" v-if="detail.brown_meat==1">瘦肉精</div>
            <div class="item" v-if="detail.chloramphenicol==1">氯霉素</div>
            <span v-if="isnormal==false">超标</span>
          </div>
          <p class="jy" v-if="isnormal==false">需要加强体内健康管理。建议您根据以下方案改善，相信很快会恢复最佳健康状态哦！</p>

          <div class="row3btn" v-if="isnormal==false">
            <div
              class="btn"
              style="background:linear-gradient(90deg,rgba(37,212,169,1) 0%,rgba(42,193,173,1) 100%);"
              @click="goanalysispage"
            >
              <img src="../assets/images/sousuo@2x.png"/>点击查看不良生活方式分析
            </div>
          </div>

          <div class="row3btn" v-if="isnormal==false">
            <div
              class="btn"
              style="background:linear-gradient(90deg,rgba(249,181,70,1) 0%,rgba(253,170,52,1) 100%);"
              @click="goguidance"
            >
              <img src="../assets/images/sousuo@2x.png"/>点击查看健康生活指导建议
            </div>
          </div>
        </div>
      </div>
      <div class="b_row4">
        <div class="title">
          <img src="../assets/images/jianceqitadusu@2x.png"/>检测其他毒素
        </div>
        <div class="rowscroll">
          <div class="item" v-for="(item,index) in ortherlist" :key="index">
            <router-link :to="{ name: 'shopDetail', params: { 'commodity_id': item.commodity_id }}">
              <div class="pic">
                <img :src="item.img"/>
              </div>
              <p>{{item.title}}</p>
            </router-link>
          </div>
          <!-- <div class="item">
						<div class="pic"><img src="../assets/images/ban1.jpg"></div>
						<p>尼古丁/NIC</p>
					</div>
          -->
        </div>
      </div>
    </div>

    <van-popup v-model="showpop" class="toum">
      <div class="pop">
        <div class="cnt">
          <div class="title">知情同意书</div>
          <div class="tip">
            <p>本检测通过采集尿液，采用胶体金技术，定性检测体内特定污染物，直观反映体内环境毒素的蓄积情况， 您需要知情以下内容: </p>
            <p class="p2">
              1. 本项目仅检测体内环境毒素的蓄积情况，并不能替代医院常规的检查。<br>
              2. 本检测结果不可作为临床诊断、疾病预防及治疗的依据。<br>
              3. 本项目中设定的阳性值与阴性值代表体内毒素水平的高低，降低毒素水平有利于降低对健康的潜在危害。<br>
            </p>
          </div>
          <div class="flex">
            <div class="greenbtn" @click.stop="close">我同意</div>
          </div>
        </div>
        <div class="closerow">
          <img src="../assets/images/gaunbi.png" class="close" @click.stop="close"/>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Popup} from 'vant'

  Vue.use(Popup)
  export default {
    data() {
      return {
        showpop: false,
        detail: {},
        isnormal: false,
        ortherlist: [],
        DeterGoodeatil: {},
        id: ''
      }
    },

    created() {
      let that = this
      that.id = that.$route.query.id
      var id = that.$route.query.id
      that.detectionbyid(id)
      that.getothaer()

      that.getfenxi()
    },

    methods: {
      //跳转商品详情
      goshopdetail(shopid) {
        let that = this
        that.$router.push({
          path: '/shopDetail',
          params: {
            commodity_id: shopid
          }
        })
      },


      getfenxi() {
        let _this = this
        _this.$http.api.findDetectionGoods().then(result => {
          console.log(result)
          _this.DeterGoodeatil = result
        })
      },
      openpop() {
        let that = this
        that.showpop = true
        console.log(this.showpop)
      },
      close() {
        console.log('关闭')
        this.showpop = false
        this.$forceUpdate()
      },
      gohistory() {
        let that = this
        that.$router.push({
          path: '/mytestcard'
        })
      },
      //跳转个人中心
      gohome() {
        let that = this
        that.$router.push({
          path: '/home'
        })
      },
      //获取其他检测霉素
      getothaer() {
        let that = this
        that.$http.api.othermycin({}).then(function (response) {
          console.log(response)
          that.ortherlist = response
        })
      },
      //根据id查询检测卡
      detectionbyid(id) {
        let that = this
        that.$http.api
          .detectionbyid({
            id: id
          })
          .then(function (response) {
            console.log(response + '哈哈哈')
            if (response != null) {
              that.detail = response
              if (
                response.nicotine == 1 ||
                response.bpa == 1 ||
                response.lemon_yellow == 1 ||
                response.brown_meat == 1 ||
                response.chloramphenicol == 1
              ) {
                that.isnormal = false
              } else {
                that.isnormal = true
              }
            } else {
              that.isnormal = true
            }
          })
      },
      // 建议 tag=2
      goguidance() {
        let that = this

        that.$router.push({
          path: '/guidance',
          query: {
            id: that.id
          }
        })
      },
      // 分析 tag =1
      goanalysispage() {
        let that = this
        that.$router.push({
          path: '/analysispage',
          query: {
            id: that.id
          }
        })
      },
      getall() {
        let that = this
        that.$http.api.suggestfindall({}).then(function (response) {
        })
      }
    }
  }
</script>
<style>
  .monitoringresults::-webkit-scrollbar {
    display: none;
  }

  ::-webkit-scrollbar {
    display: none;
  }
</style>
<style lang="less" scoped>
  .pop {
    width: 315px;
    height: auto;
    background-color: transparent;

    .cnt {
      width: 100%;
      background-color: #ffffff;
      color: #707070;

      .title {
        width: 100%;
        height: 62px;
        line-height: 62px;
        background: linear-gradient(180deg,
        rgba(45, 186, 177, 1) 0%,
        rgba(39, 211, 173, 1) 100%);
        color: #ffffff;
        font-size: 17px;
        text-align: center;
      }

      .tip {
        padding: 20px 15px 30px;
        box-sizing: border-box;
        height: 260px;
        overflow-y: scroll;

        .p1 {
          span {
            color: #27d3ad;
          }
        }

        .p2 {
          line-height: 23px;
          font-size: 12px;
        }

        .p2 {
          margin-top: 24px;
        }
      }

      .flex {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        height: 80px;

        .greenbtn {
          text-align: center;
          width: 140px;
          height: 34px;
          line-height: 34px;
          background: linear-gradient(180deg,
          rgba(45, 186, 177, 1) 0%,
          rgba(39, 211, 173, 1) 100%);
          color: #ffffff;
          font-size: 15px;
          border-radius: 20px;
        }
      }
    }
  }

  .monitoringresults {
    width: 100%;
    height: 100vh;
    background-color: #ededed;

    .toum {
      background-color: transparent;

      .closerow {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        height: 60px;

        .close {
          width: 25px;
          height: 25px;
        }
      }
    }

    .top {
      color: #6d6d6d;
      font-size: 13px;
      padding: 10px 14px;
      box-sizing: border-box;
      background-color: #fff;
      line-height: 24px;

      span {
        color: #2bbcaf;
      }
    }

    .bottom {
      width: 100%;
      padding: 10px 14px;
      box-sizing: border-box;

      .jy {
        font-size: 15px;
        margin: 15px 0px;
      }

      .row3btn {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        margin-bottom: 12px;

        .btn {
          font-size: 13px;
          color: #fff;
          height: 34px;
          line-height: 34px;
          padding: 0px 22px;
          box-sizing: border-box;
          border-radius: 17px;
          display: flex;
          display: -webkit-flex;
          align-items: center;

          img {
            width: 13px;
            height: auto;
            margin-right: 5px;
          }
        }
      }

      .b_row4 {
        width: 100%;
        height: auto;
        background-color: #ffffff;
        border-radius: 4px;
        margin-top: 10px;
        color: #6d6d6d;
        padding-bottom: 36px;

        .title {
          width: 100%;
          height: 40px;
          font-size: 16px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          padding-left: 18px;
          box-sizing: border-box;
          border-bottom: 1px solid #efefef;
          color: #2bbcaf;

          img {
            width: 24px;
            height: 24px !important;
            margin-right: 6px;
          }
        }

        .rowscroll {
          width: auto;
          scrollbar-width: none;
          /* firefox */
          -ms-overflow-style: none;
          /* IE 10+ */
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          height: auto;
          margin-top: 7px;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;

          .item {
            // width: 1.68rem;
            height: auto;
            margin-right: 0.1rem;

            .pic {
              width: 2.1rem;
              height: 57px;
              background-color: #efefef;
              position: relative;

              img {
                position: absolute;
                top: 12px;
                left: 0px;
                right: 0px;
                margin: auto;
                width: 50px;
                height: 35px !important;
                object-fit: cover;
                height: auto;
              }
            }

            p {
              text-align: center;
              font-size: 9px;
              margin-top: 5px;
            }
          }
        }
      }

      .b_row3 {
        width: 100%;
        height: auto;
        background-color: #ffffff;
        border-radius: 4px;
        margin-top: 10px;
        color: #6d6d6d;

        .cnt {
          width: 100%;
          padding: 12px 17px !important;
          box-sizing: border-box;

          .cbrow {
            width: 100%;
            border-bottom: 1px solid #efefef;
            display: flex;
            display: -webkit-flex;
            margin-top: 20px;
            // padding-bottom: 10px;
            box-sizing: border-box;
            align-items: center;
            position: relative;
            flex-wrap: wrap;

            span {
              position: absolute;
              top: 0.13rem;
              right: 0px;
              bottom: 0px;
              margin: auto;
              color: #fbaa34;
            }

            .item {
              background-color: #fbaa34;
              border-radius: 4px;
              margin-right: 7px;
              color: #ffffff;
              padding: 4px 6px;
              margin-bottom: 0.2rem;
              font-size: 0.34rem;
            }
          }
        }

        .title {
          width: 100%;
          height: 40px;
          font-size: 16px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          padding-left: 18px;
          box-sizing: border-box;
          border-bottom: 1px solid #efefef;

          img {
            width: 24px;
            height: 24px;
            margin-right: 6px;
          }
        }
      }

      .b_row2 {
        margin-top: 10px;
        padding: 20px 15px;
        box-sizing: border-box;
        background-color: #ffffff;
        color: #6d6d6d;
        font-size: 15px;

        span {
          color: #2bbcaf;
        }

        p {
          text-indent: 2em;
          line-height: 28px;
        }
      }

      .b_row1 {
        width: 100%;
        height: 50px;
        display: flex;
        display: -webkit-flex;
        background-color: #ffffff;
        align-items: center;
        padding: 0px 10px 0px 10px;
        box-sizing: border-box;
        // justify-content: space-around;
        border-radius: 4px;
        position: relative;

        .btn {
          width: 60px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          background-color: #fbaa34;
          font-size: 11px;
          color: #ffffff;
          border-radius: 10px;
        }

        .right {
          width: 50px;
          height: 38px;
          position: absolute;
          top: 0px;
          right: 0.5rem;
          bottom: 0px;
          margin: auto;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .center {
          color: #6d6d6d;
          margin: 0px 0.2rem 0px 0.3rem;
          width: 55%;

          .p1 {
            font-size: 12px;
          }

          .p2 {
            font-size: 7px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .canvas {
      width: 100%;
      height: auto;
      background: linear-gradient(180deg,
      rgba(45, 186, 177, 1) 0%,
      rgba(39, 211, 173, 1) 100%);
      padding: 1px;

      .jyday {
        width: 100%;
        color: #ffffff;
        font-size: 0.34rem;
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 0.35rem;
      }

      .chatsbottom {
        width: 74%;
        height: 3.5rem;
        border-bottom: 1px solid #ffffff;
        border-left: 1px solid #ffffff;
        margin-left: 20%;
        margin-top: 0.7rem;
        position: relative;

        .span1 {
          position: absolute;
          font-size: 0.32rem;
          color: #ffffff;
          left: -1.2rem;
          bottom: 1.9rem;
          text-align: center;
        }

        .row {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: flex-end;
          position: absolute;
          bottom: 0px;

          .solid {
            width: 100%;
            display: table;
            position: absolute;
            bottom: 2.31rem;
            height: 1px;
            border-bottom: 1px dashed #ffffff;
          }
        }

        .row1 {
          width: 96%;
          display: flex;
          display: -webkit-flex;
          color: #ffffff;
          font-size: 0.3rem;
          justify-content: space-between;
          position: absolute;
          bottom: -0.6rem;
        }

        .zzt {
          width: 25%;
          display: flex;
          display: -webkit-flex;
          // position: absolute;
          bottom: 0px;
          align-items: flex-end;
          margin-left: 0.4rem;
          margin-right: 0.3rem;
          position: relative;

          img {
            width: 0.7rem;
            height: auto;
            position: absolute;
            top: -0.5rem;
            right: 0px;
          }

          .zztitem {
            width: 0.2rem;
            height: 2.31rem;
            margin-right: 0.1rem;
            background: linear-gradient(180deg,
            rgba(165, 251, 248, 1) 0%,
            rgba(255, 255, 255, 1) 100%);
          }

          .zztitem1 {
            width: 0.2rem;
            height: 2.65rem;
            background: linear-gradient(180deg,
            rgba(252, 195, 85, 1) 0%,
            rgba(254, 254, 252, 1) 100%);
            margin-right: 0.1rem;
          }
        }
      }

      .c_top {
        width: 100%;
        color: #ffffff;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        padding: 0px 14px;
        box-sizing: border-box;
        margin: 14px auto;

        .left {
          display: flex;
          display: -webkit-flex;
          align-items: center;

          img {
            width: 15px;
            height: 16px;
            margin-right: 5px;
          }
        }

        .right {
          display: flex !important;
          display: -webkit-flex !important;
          align-items: center;

          img {
            width: 19px;
            height: 19px;
            margin-right: 5px;
          }
        }

        .center {
        }
      }
    }
  }
</style>
